import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CompassQuestionAnswers extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'CompassQuestionAnswers'
  // Define default properties here
  static instanceDefaults () {
    return {
      value: null,
      compassQuestionId: null,
      userId: null,
      categoryId: null,
      voteTypeId: null,
    }
  }
}
const servicePath = 'compass-question-answers'
const servicePlugin = makeServicePlugin({
  Model: CompassQuestionAnswers,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
